/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function UserLockIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="user-lock"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <circle cx={10.592} cy={9.5} r={4.408} stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M14 19.294C14 16.859 14.271 16.588 16.706 16.588L19.294 16.588C21.729 16.588 22 16.859 22 19.294C22 21.729 21.729 22 19.294 22L16.706 22C14.271 22 14 21.729 14 19.294Z" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(80)} data-tinysvg-stroke-width="80" />
          <path d="M16.118 16.588L16.118 15.882C16.118 14.843 16.96 14 18 14C19.04 14 19.882 14.843 19.882 15.882L19.882 16.588" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" strokeWidth={scaledStrokeWidth(80)} data-tinysvg-stroke-width="80" />
          <path d="M5 20.588C6.223 18.426 8.515 17.088 11 17.088C11.178 17.088 11.355 17.095 11.53 17.109" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
